import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Stack,
  Typography,
} from '@mui/material';
import { Button } from '../atoms/Button';
import { useUpdateMerchantStatusType } from '../../hooks/merchant';
import { useSetSnackBar } from '../../store/Snackbar.state';

export type ActivateModalProps = {
  isOpen: boolean;
  onClose: () => void;
  merchantId: number | null;
  merchantName?: string;
  onSuccess?: () => void;
};

export const ActivateModal: React.FC<ActivateModalProps> = ({
  isOpen,
  onClose,
  merchantId,
  merchantName,
  onSuccess
}) => {
  const setSnackbar = useSetSnackBar();
  const { mutate: updateMerchantStatus, isLoading: isUpdating } = useUpdateMerchantStatusType();

  const handleSubmit = () => {
    if (!merchantId) {
      setSnackbar({
        severity: "error",
        description: "İşyeri seçilmedi.",
        isOpen: true,
      });
      return;
    }

    updateMerchantStatus(
      {
        merchantId: merchantId,
        processType: 2,
      },
      {
        onSuccess: (data) => {
          if (data.isSuccess) {
            setSnackbar({
              severity: "success",
              description: data.message || "İşyeri başarıyla aktif şirketler listesine eklendi.",
              isOpen: true,
            });
            onClose();
            if (onSuccess) {
              onSuccess();
            }
          } else {
            setSnackbar({
              severity: "error",
              description: data.message,
              isOpen: true,
            });
          }
        },
        onError: (error: any) => {
          setSnackbar({
            severity: "error",
            description: error?.message || "İşlem sırasında bir hata oluştu.",
            isOpen: true,
          });
        },
      }
    );
  };

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        Aktif Şirketler Listesine Ekle
      </DialogTitle>
      <DialogContent>
        <Stack spacing={3} sx={{ mt: 1 }}>
          {merchantName && (
            <Typography variant="body1">
              <strong>İşyeri:</strong> {merchantName}
            </Typography>
          )}
          
          <Typography variant="body2" color="text.secondary">
            Bu işyerini aktif şirketler listesine eklemek istediğinizden emin misiniz?
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button
          text="İptal"
          variant="outlined"
          onClick={onClose}
          disabled={isUpdating}
        />
        <Button
          text="Aktif Şirketler Listesine Ekle"
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          disabled={isUpdating}
          sx={{
            backgroundColor: '#002abe',
            '&:hover': {
              backgroundColor: '#0025be',
            }
          }}
        />
      </DialogActions>
    </Dialog>
  );
};